exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-count[data-v-0d9af265] {\n  margin-left: 0.4rem;\n  background-color: #25C8C1;\n  color: white;\n  font-family: Axiforma, sans-serif;\n  font-size: 1rem;\n  line-height: 1.2rem;\n  border-radius: 0.4rem;\n  padding: 0.2rem 0.5rem 0.1rem;\n}", ""]);

// exports
